import ajax from '../http/ajax'

export const getAggregationInfo = params => {
    return ajax.get('getAggregationInfo', params)
}

export const getAggregationList = params => {
    return ajax.get('getAggregationList', params)
}
